/*=========================================================================================
  File Name: moduleVehicleActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Api from "@/helpers/api.js";
import {
	createVehiclePaginatedPayload,
	createDatarutasResourcePayload,
	processVehicleRecords,
	commitVehicles,
} from "@/store/payloadHelper.js";

export default {
	save({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/vehicle", payload)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	update({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.put(`/vehicle/${payload.id}`, payload.items)
				.then((response) => {
					commit("UPDATE_VEHICLE", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	findById({commit}, id) {
		return new Promise((resolve, reject) => {
			Api.get(`/vehicle/${id}`)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	findAll({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/vehicle")
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	deleteById({commit}, id) {
		return new Promise((resolve, reject) => {
			Api.delete(`/vehicle/${id}`)
				.then((response) => {
					commit("REMOVE_VEHICLE", id);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	findVehiclePaginated({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = createVehiclePaginatedPayload(data);
			Api.post("/vehicle/filter", payload)
				.then((res) => {
					const processedRecords = processVehicleRecords(res.data.records, data);
					commitVehicles(commit, processedRecords, data);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	currentVehicleSelected({commit}, payload) {
		return new Promise((resolve, reject) => {
			commit("SELECTED_VEHICLE", payload);
			resolve(payload);
		});
	},
	fetchDatarutasResource({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = createDatarutasResourcePayload(data);
			Api.post("/datarutas/resource/filter", payload)
				.then((res) => {
					commit("SET_DATARUTAS_RESOURCE", res.data.records);
					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},
};
